module.exports = __webpack_public_path__ + "img/taichungall.296c6c7d.jpg";